module.exports = __webpack_public_path__ + "static/media/racivid3.25314238.png";